import '~/entrypoints/config/init';
import Vue from 'vue';
import SuggestedMergesBanner from '~/components/merge_members/SuggestedMergesBanner.vue';

function mount() {
  document.querySelectorAll('[data-vue="merge_members_banner"]').forEach((el) => {
    const orgId = Number(el.dataset.organizationId);
    const initialCount = Number(el.dataset.initialCount);
    const initialIds = (el.dataset.ids || '').split(',').filter(Boolean).map(Number);

    new Vue({
      render: (h) =>
        h(SuggestedMergesBanner, {
          props: { organizationId: orgId, initialCount, initialIds },
        }),
    }).$mount(el);
  });
}

document.addEventListener('DOMContentLoaded', mount);
